<template>
  <div class="content">
    <div class="login-wrapper">
      <div class="login">
        <h5 class="text-center">Park Ave</h5>
        <h5 class="text-center">Personal Health Record</h5>
        <form @submit.prevent="onSubmit" class="form" ref="formContainer">
          <div class="b-form-group form-group" role="group" id="exampleInputGroup1">
            <label class="col-form-label pt-0">Username: </label>
            <input
              id="exampleInput1"
              type="text"
              v-model="form.patient"
              class="form-control form__input"
              required
              placeholder="Enter username"
            />
          </div>
          <div class="b-form-group form-group" role="group" id="exampleInputGroup2">
            <label class="col-form-label pt-0">Password: </label>
            <input
              id="exampleInput2"
              v-model="form.password"
              class="form-control form__input"
              required
              type="password"
              placeholder="Enter password"
            />
          </div>
          <div class="button-group">
            <button type="submit" class="col-md-12 col-12 btn btn--login">Log in</button>
            <router-link to="/forgot" class="form__link">Forgot password</router-link>
            <router-link to="/register" class="form__link"
              >I don't have an account</router-link
            >
            <div v-bind:class="messageClass" v-html="statusMessage"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { LoggedIn, LoggingIn } from "@/store/modules/fsm/messages";
import router from "@/router/index";
import { mapActions } from "vuex";
import { post } from "@/store/modules/fsm/index";
export default {
  name: "login-page",
  data() {
    return {
      form: {
        patient: "",
        password: "",
      },
      fullPage: false,
      statusMessage: "",
    };
  },
  props: {
    dest: "",
  },
  computed: {
    messageClass: function () {
      return this.statusMessage.length === 0 ? "d-none" : "alert alert-warning";
    },
  },
  methods: {
    ...mapActions("login", ["login"]),
    onSubmit(e) {
      // let form = this.form;

      this.statusMessage = "";
      post({
        message: LoggingIn,
        loader: this.$loading.show(
          {
            container: this.$refs.formContainer,
          },
          {
            after: this.$createElement("div", {}, [`Retrieving application data...`]),
          }
        ),
        ...this.form,
        LoginPage: this,
      });

      // NOTE: the function above should return status of the log in request
      //  so that further actions can be taken based on the status
      //  e.g.: emitting an event that tells server pulse checker to start up
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
$color-base: #0060ff;
.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed; // TODO image subject to copyright
  background-size: cover;
  position: relative;
}
.login-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.login {
  background-color: #fff;
  padding: 2rem;
  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);

  @include absoluteCenter(380px);
}
.login__introduction {
  color: darken(gray, 10%);
  font-size: 14px;
  text-align: center;
}
.btn--login {
  color: #fff;
  background-color: $color-base;
  &:hover {
    background-color: lighten($color-base, 5%);
  }
}

.button-group {
  margin-top: 1.5rem;

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}

.form__input {
  font-size: 0.85rem;
}
.col-form-label {
  font-size: 14px;
}

@media only screen and (max-width: 468px) {
  .login {
    width: 100%;
  }
}
</style>
